import { render, staticRenderFns } from "./moreoption.vue?vue&type=template&id=99c6eb08&scoped=true&"
import script from "./moreoption.vue?vue&type=script&lang=ts&"
export * from "./moreoption.vue?vue&type=script&lang=ts&"
import style0 from "./moreoption.vue?vue&type=style&index=0&id=99c6eb08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c6eb08",
  null
  
)

export default component.exports